export default __webpack_public_path__ + "79c23ff0104f3c7f0fca8950d2814c0b.png";